// Popular short VSP city-to-city routes (both directions for full coverage).
// Dependency-free. `from`/`to` are slugs from lib/cities.js.
export const TRIP_PATH = "/itineraire-voiture-sans-permis";

const BASE_TRIPS = [
  { from: "aix-en-provence", to: "marseille" },
  { from: "montpellier", to: "nimes" },
  { from: "montpellier", to: "beziers" },
  { from: "nancy", to: "metz" },
  { from: "mulhouse", to: "colmar" },
  { from: "lille", to: "valenciennes" },
  { from: "lille", to: "dunkerque" },
  { from: "lorient", to: "vannes" },
  { from: "quimper", to: "lorient" },
  { from: "saint-nazaire", to: "nantes" },
  { from: "la-rochelle", to: "niort" },
  { from: "avignon", to: "nimes" },
  { from: "chambery", to: "annecy" },
  { from: "cholet", to: "angers" },
  { from: "bayonne", to: "pau" },
  { from: "colmar", to: "strasbourg" },
  { from: "calais", to: "boulogne-sur-mer" },
  { from: "carcassonne", to: "narbonne" },
  { from: "arras", to: "lille" },
];

// Expand to both directions (A→B and B→A) to double the SEO coverage.
export const TRIPS = BASE_TRIPS.reduce((acc, t) => {
  acc.push({ from: t.from, to: t.to });
  acc.push({ from: t.to, to: t.from });
  return acc;
}, []);

export function tripSlug(t) {
  return `${t.from}-${t.to}`;
}

export function findTrip(slug) {
  return TRIPS.find((t) => tripSlug(t) === slug) || null;
}

export function tripsFromCity(citySlug) {
  return TRIPS.filter((t) => t.from === citySlug);
}
